import React, { Component, useState } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import { ModalTypes, ModalService } from "../../../service/modal-service";
import PlaylistService from "../../../service/playlist-service";

import { Box } from "../../../comps";
import Error from "../../views/error";
import PlaylistCard from "./playlist-card";
import { InputModal } from "../../../modals";

const gradients = [
  `040330`,
  `1c4726`,
  `17323b`,
  `3d2215`,
  `94031e`,
  `003647`,
  `2b2a29`,
];

const ErrorWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const Wrap = styled.div`
  width: 100%;
  /* will scroll only if height of parent is fixed */
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

export default class extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    if (document.getElementsByClassName("playlistGrid").length > 0)
      this.grid = new MuuriGrid(".grid", {
        dragEnabled: true,
        rounding: true,
        layout: { fillGaps: true, alignLeft: true, alignTop: true },
      });
  }

  handleCreatePlaylist = async (name) => {
    await PlaylistService.createNewPlaylist({ name });
  };

  createNewPlaylist = () => {
    console.log("creating new pl");
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "180px",
      content: (
        <InputModal
          title="Create new Playlist"
          placeholder="Name of the playlist"
          submit="create"
          onSubmit={this.handleCreatePlaylist}
        />
      ),
    });
  };

  render() {
    const { playlists } = this.props;
    const availWidth = window.screen.width - 150;
    const w = (20 * availWidth) / 100.0;
    const h = w + (20 * w) / 100.0;
    const m = (availWidth - 4 * w) / 8 - 10; // margin

    if (playlists && playlists.length > 0) {
      return (
        <Wrap>
          <div class="grid playlistGrid">
            {playlists.map((playlist, idx) => {
              const color = "#" + gradients[idx % gradients.length] + "fa";
              return (
                <PlaylistCard
                  width={w + "px"}
                  height={h + "px"}
                  margin={m + "px"}
                  color={color}
                  playlistInfo={playlist}
                />
              );
            })}
          </div>
        </Wrap>
      );
    }
    return (
      <ErrorWrapper onClick={this.createNewPlaylist}>
        <Error message="You have not created any playlist. Create one!" />
      </ErrorWrapper>
    );
  }
}
